export default __webpack_public_path__ + "static/media/3.3eb6e931.jpg";